import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import round from "lodash/round";

import { ISelectedPlan } from "./types";
import Price from "../../../../components/Price";
import { getInterval } from "../../../../utils/common";

import "./styles.scss";

export const SelectedPlan: FC<ISelectedPlan> = ({ plan, features }) => {
  const { t } = useTranslation();
  const pricePerLicense = round(plan.geoCost.amount / (plan.licenses || 1), 2);
  const internal = useMemo(() => {
    return plan.sp.billing_period ? getInterval(plan.sp.billing_period) : null;
  }, [plan]);

  return (
    <div className="ams-selected-plan">
      <div className="ams-selected-plan__info">
        <div className="ams-selected-plan__title">{plan.sp.name}</div>
        <div className="ams-selected-plan__price">
          <Price
            currencyCode={plan.geoCost.currency}
            amount={pricePerLicense}
          />
          {t("pricePerLicensePerYear")}
        </div>
        {features && (
          <ul className="ams-selected-plan__features">
            {features.map((item) => {
              return (
                <li key={item} className="ams-selected-plan__feature">
                  {t(item)}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      <div className="ams-selected-plan__summary">
        <div className="ams-selected-plan__summary-row">
          <span>{plan.sp.name}</span>
          <span>
            <Price
              currencyCode={plan.geoCost.currency}
              amount={pricePerLicense}
            />
            {t("pricePerSeat")}
          </span>
        </div>
        <div className="ams-selected-plan__summary-price">
          <Price
            currencyCode={plan.geoCost.currency}
            amount={pricePerLicense}
          />
          {internal
            ? t("priceForLicenseForPeriod", {
                licenses: plan.licenses,
                unit: t(internal.unit, {
                  [internal.unit]: internal.length,
                }),
                duration: internal.length,
              })
            : null}
        </div>
        <div className="ams-selected-plan__summary-row ams-selected-plan__summary-row--total">
          <span>{t("totalCost")}</span>
          <Price
            currencyCode={plan.geoCost.currency}
            amount={plan.geoCost.amount}
          />
        </div>
      </div>
    </div>
  );
};
